import { useState, useCallback } from 'react';
import { useDispatch } from '../store';
import { getUserAccessToken } from '../store/customers/customers.slice';

const whatsappDemoUrl = new URL(window.location.href);

export function useStartDemo() {
  const dispatch = useDispatch();
  const [loadingDemo, setLoadingDemo] = useState(false);

  const startDemo = useCallback(async () => {
    try {
      setLoadingDemo(true);
      const user = JSON.parse(localStorage.getItem('currentUser'));
      const { accessToken } = await dispatch(getUserAccessToken({ userId: user._id }));

      const newWindow = window.open(
        `${whatsappDemoUrl?.origin}/whatsapp/demo/manage-account/${accessToken}`,
        '_blank',
        'noopener,noreferrer'
      );

      if (newWindow) newWindow.opener = null;
    } catch (error) {
      console.error('Error starting demo:', error);
    } finally {
      setLoadingDemo(false);
    }
  }, [dispatch]);

  return { startDemo, loadingDemo };
}
